import React, { useEffect } from 'react'
import Footer from '../footer'
import Header from '../header'
import { useParams } from 'react-router-dom'
import { JournalList } from "../../Redux/journal/journalslice";
import { useDispatch, useSelector } from "react-redux";
import ContentRenderer from '../ContentRender';
// import { Link } from 'react-router-dom'

const TermsandConditions = () => {

    const { name } = useParams();
    const dispatch = useDispatch();
    const { journalList } = useSelector((state) => state.jounalListData)

    useEffect(() => {
        dispatch(JournalList(window.atob(name)));
    }, [name])

    // const RemoveTags = (string) => {
    //   const withoutTags = string?.replace(/<\/?[^>]+(>|$)/g, "");
    //   return withoutTags;
    // }

    return (
        <>
            <Header />
            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <div className="breadcrumb-list">
                                <nav aria-label="breadcrumb" className="page-breadcrumb">
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            {/* <h1 className="mb-0">Terms &amp; Conditions</h1> */}
                            <h1 className="mb-0">{journalList?.data?.page_heading}</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className='topspace'>
                <div className="page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className="terms-content">
                                            <div className="terms-text">
                                                {/* <div dangerouslySetInnerHTML={{ __html: journalList?.data?.page_content }}></div> */}
                                                <ContentRenderer content={journalList?.data?.page_content} />
                                            </div>
                                            {/* <div className="terms-text">
                                                <h4>This is a H2&apos;s perfect for the titles.</h4>
                                                <p>
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Stress,
                                                    for the United States element ante. Duis cursus, mi quis viverra
                                                    ornare, eros pain , sometimes none at all, freedom of the living
                                                    creature was as the profit and financial security. Jasmine neck
                                                    adapter and just running it lorem makeup hairstyle. Now sad smile
                                                    of the television set.
                                                </p>
                                                <ul>
                                                    <li>More than 60+ components</li>
                                                    <li>Five ready tests</li>
                                                    <li>Coming soon page </li>
                                                    <li>Check list with left icon</li>
                                                    <li>And much more ...</li>
                                                </ul>
                                            </div>
                                            <div className="terms-text">
                                                <h4>This is a H2&apos;s perfect for the titles.</h4>
                                                <p>
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Stress,
                                                    for the United States element ante. Duis cursus, mi quis viverra
                                                    ornare, eros pain , sometimes none at all, freedom of the living
                                                    creature was as the profit and financial security. Jasmine neck
                                                    adapter and just running it lorem makeup hairstyle. Now sad smile
                                                    of the television set.
                                                </p>
                                            </div>
                                            <div className="terms-text">
                                                <h4>Changes about terms</h4>
                                                <p>
                                                    If we change our terms of use we will post those changes on this
                                                    page. Registered users will be sent an email that outlines changes
                                                    made to the terms of use.
                                                </p>
                                                <p>
                                                    Questions? Please email us at
                                                    <Link to="#"> Email@example.com</Link>
                                                </p>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default TermsandConditions